import httpClient from '@yola/http-client';

const FONTS_DATA_URL = '/assets/fonts.json';

let cache = null;
let pendingPromise = null;

const loadFontsData = () => {
  if (cache) {
    return Promise.resolve(cache);
  }

  if (!pendingPromise) {
    pendingPromise = httpClient
      .get(FONTS_DATA_URL)
      .then(({ data }) => {
        cache = data;
        pendingPromise = null;
        return cache;
      })
      .catch((error) => {
        pendingPromise = null;
        throw error;
      });
  }

  return pendingPromise;
};

export { loadFontsData };
